<template>
  <div v-if="visible" class="sound-dropdown-menu" @click.stop>
    <!-- 音效选项列表 -->
    <div class="sound-dropdown-content">
      <div
        v-for="option in soundOptions"
        :key="option.value"
        class="sound-option-item"
        :class="{ active: currentSound === option.value }"
        @click="selectSound(option.value)"
      >
        <span class="sound-label">{{ option.label }}</span>
        <div v-if="currentSound === option.value" class="check-mark">
          <svg viewBox="0 0 16 16" fill="none">
            <path d="M3 8L6.5 11.5L13 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue'

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  currentSound: {
    type: String,
    default: 'default'
  }
})

const emit = defineEmits(['update:visible', 'sound-change'])

// 音效选项配置
const soundOptions = [
  { label: '静音', value: 'mute' },
  { label: '默认', value: 'default' },
  { label: '哨子', value: 'whistle' },
  { label: '鼓声', value: 'drum' },
  { label: '广播', value: 'broadcast' },
  { label: '号角', value: 'horn' },
  { label: '胜利', value: 'victory' }
]

/**
 * 选择音效
 */
const selectSound = (value) => {
  emit('sound-change', value)
  // 选择后关闭下拉菜单
  emit('update:visible', false)
}
</script>

<style scoped lang="scss">
.sound-dropdown-menu {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  width: 90px;
  background: $scoreFootball-white;
  border-radius: 10px;
  border: 1px solid $scoreFootball-border-light;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  // 内容区域
  .sound-dropdown-content {
    padding: 8px 0;
    max-height: 320px;
    overflow-y: auto;

    .sound-option-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 16px;
      cursor: pointer;
      transition: all 0.2s ease;
      position: relative;
      user-select: none;

      .sound-label {
        font-size: 12px;
        font-weight: 500;
        color: #afb8cb;
        flex: 1;
      }

      .check-mark {
        width: 16px;
        height: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 8px;
        flex-shrink: 0;

        svg {
          width: 14px;
          height: 14px;
          color: $color-primary;
        }
      }

      &:hover {
        background: #f5f7fa;

        .sound-label {
          color: $color-primary;
        }
      }

      &.active {
        background: rgba($color-primary, 0.08);

        .sound-label {
          color: $color-primary;
          font-weight: 600;
        }
      }
    }
  }

  // 滚动条样式
  .sound-dropdown-content::-webkit-scrollbar {
    width: 6px;
  }

  .sound-dropdown-content::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  .sound-dropdown-content::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;

    &:hover {
      background: #a1a1a1;
    }
  }
}
</style>
